<ion-app>
	<div *ngIf="isDeprecated$ | async" class="alert-deprecated-banner">
		⚠️ Tienes una versión obsoleta de la aplicación. Por favor, actualiza en tu tienda de aplicaciones.
		Mientras no lo hagas, es posible que algunas funcionalidades no operen correctamente.
	</div>

	<div *ngIf="isObsolete$ | async" class="obsolete-overlay">
		<div class="obsolete-content">
			<ion-icon name="cloud-download-outline"></ion-icon>
			<h2>Actualización necesaria</h2>
			<p>{{ (obsoleteMessage$ | async) || 'Esta versión de la aplicación ya no es compatible. Por favor, descarga
				la última versión disponible para continuar operando con normalidad.' }}</p>
			<ion-button *ngIf="storeUrl$ | async" expand="block" (click)="openStore()">Actualizar ahora</ion-button>
		</div>
	</div>

	<ion-split-pane contentId="main-content">
		<!--  our side menu  -->
		<ion-menu contentId="main-content">
			<ion-header>
				<ion-toolbar color="primary">
					<ion-title>{{'MENU.menu'|translate}}</ion-title>
				</ion-toolbar>
			</ion-header>
			<ion-content>
				<div class="head-menu-izq"> <img src="assets/img/arriva_logo_c.svg" width="90" alt="Arriva"> <br>
					<h3 class="margin-small-top">Arriva Galicia</h3>
				</div>
				<ion-list *ngIf="isAuth">
					<ion-list-header>
						{{'MENU.tu_cuenta'|translate}}
					</ion-list-header>
					<ion-menu-toggle autoHide="false">
						<ion-item routerLink="/perfil" routerDirection="root" lines="none">
							<ion-icon slot="start" name="person"></ion-icon>
							<ion-label>
								{{'MENU.editar_perfil'|translate}}
							</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle autoHide="false">
						<ion-item button (click)="logout()" lines="none">
							<ion-icon slot="start" name="log-out"></ion-icon>
							<ion-label>
								{{'MENU.cerrar_sesion'|translate}}
							</ion-label>
						</ion-item>
					</ion-menu-toggle>
				</ion-list>
				<ion-list>
					<ion-list-header>
						{{'MENU.secciones'|translate}}
					</ion-list-header>

					<ion-menu-toggle autoHide="false">
						<ion-item [routerLink]="['/tabs/inicio/mapa-paradas']" lines="none">
							<ion-icon slot="start" name="map"></ion-icon>
							<ion-label>
								{{'MENU.mapa_paradas'|translate}}
							</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle autoHide="false">
						<ion-item [routerLink]="['/tabs/inicio/paradas-favoritas']" lines="none">
							<ion-icon slot="start" name="heart-outline"></ion-icon>
							<ion-label>
								{{'MENU.paradas_favoritas'|translate}}
							</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle autoHide="false">
						<ion-item [routerLink]="['/ayuda']" lines="none">
							<ion-icon slot="start" name="help-buoy-outline"></ion-icon>
							<ion-label>
								{{'MENU.ayuda'|translate}}
							</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle autoHide="false">
						<ion-item [routerLink]="['/acerca']" lines="none">
							<ion-icon slot="start" name="information-circle-outline"></ion-icon>
							<ion-label>
								{{'MENU.acerca'|translate}}
							</ion-label>
						</ion-item>

						<ion-item>
							<ion-label>{{'GENERAL.escoger_idioma'|translate}}</ion-label>
							<ion-select cancelText="{{'GENERAL.cancelar'|translate}}"
								okText="{{'GENERAL.ok'|translate}}" placeholder="{{'GENERAL.seleccionar'|translate}}"
								name="model" #model="ngModel" [(ngModel)]="selectedLanguage"
								(ionChange)="languageChanged()">
								<ion-select-option value="es">Español</ion-select-option>
								<ion-select-option value="gl">Galego</ion-select-option>
							</ion-select>
						</ion-item>



					</ion-menu-toggle>
				</ion-list>
				<ion-list>
					<ion-list-header>
						{{'MENU.legal'|translate}}
					</ion-list-header>

					<ion-menu-toggle autoHide="false">
						<ion-item [routerLink]="['/terminos-legales']" lines="none">
							<ion-label><small>{{'MENU.terminos_servicio'|translate}}</small></ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle autoHide="false">
						<ion-item [routerLink]="['/privacidad']" lines="none">
							<ion-label><small>{{'MENU.politica_privacidad'|translate}}</small></ion-label>
						</ion-item>
					</ion-menu-toggle>
				</ion-list>

			</ion-content>
		</ion-menu>

		<!-- the main content -->
		<ion-router-outlet id="main-content"></ion-router-outlet>
	</ion-split-pane>
</ion-app>